// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__2g_F7","logo":"footer_logo__2ueIU","column":"footer_column__2gUQB","desktopLinks":"footer_desktopLinks__2rwgp","mobileLinks":"footer_mobileLinks__34JZ1"};